import { useMutation } from '@tanstack/react-query';
import type { AxiosError, AxiosInstance, AxiosResponse } from 'axios';

import { useAxiosConfig } from '#/shared/hooks/useAxiosConfig';
import { useTimesheetStore } from '#/shared/stores/timesheetStore';

import { ApproveTimesheetApiData } from '../types/ApproveTimesheetApi';

// TODO: PPL-2240-verify-timesheet-action cleanup - Remove this default url as API will return the correct url
const DEFAULT_APPROVE_URL = '/timesheet-online-approval/approve';

export type ApproveTimesheetMutationVariables = {
  data: ApproveTimesheetApiData;
};

export const approveTimesheet = async ({
  api,
  url,
  data,
}: { api: AxiosInstance; url: string } & ApproveTimesheetMutationVariables): Promise<AxiosResponse> => {
  return api.patch(url, data);
};

export const useApproveTimesheetMutation = () => {
  const api = useAxiosConfig();
  const url = useTimesheetStore(state => state.links?.approve?.href ?? DEFAULT_APPROVE_URL);

  return useMutation<AxiosResponse, AxiosError, ApproveTimesheetMutationVariables>({
    mutationFn: variables => approveTimesheet({ api, url, ...variables }),
  });
};
